import { EntityAboutCard } from '../EntityAboutCard/EntityAboutCard';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Project } from '@internal/plugin-pulse-common';

export function ProjectAboutCard() {
  const { entity } = useEntity();
  const spec = (entity?.spec as Project) ?? {};

  const fields = {
    Region: spec.region,
    Industry: spec.industry,
    'Project Manager': spec.projectManager,
    'Technical Lead': spec.technicalLead,
    'Start Date': spec.startDate,
    'End Date': spec.endDate,
    Account: spec.account,
  };

  return <EntityAboutCard fields={fields} title="About" />;
}
